
import React from "react";
import styled from "@emotion/styled";
import colors from '../../../sass/brand_palette.scss';
import withTranslator from '../Translator/withTranslation';


const USPContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size:1em;
    @media (max-width: 576px) { 
        font-size:0.8em;
    }
`;

const USPItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const USPCell = styled.div `
width: 48%;
height: 100px;
margin-bottom: 4em;
text-align:center;
@media (min-width:576px) {
    width: 32%;
    height: 100px;
    margin-bottom: 4em;
    text-align:center;
}
`
const USPImg = styled.img`
    width: 50px;
`;

const USPIcon = styled.div`
    border: 4px solid ${colors.orange2};
    padding: 15px;
    border-radius: 100%;
    width:80px;
    height:80px;
`;
const USPText = styled.div `
    margin-top:1em;
`
const USPComponent = (props) => {
    const t = props.t;
    return (
        <USPContainer className="flex justify-sbetween p-3">
            <h2 className="px-3 pb-4 width-100 text-center font-w600">{props.t('usp_why_book')}</h2>
            <USPCell>
                <USPItem>
                    <USPIcon className="usp-icon"><USPImg src="/assets/img/front/usp/usp-holidays.svg"   /></USPIcon>
                    <USPText className="usp-text">{props.t('usp_getaway')}</USPText>
                </USPItem>
            </USPCell>
            <USPCell>
                <USPItem>
                <USPIcon className="usp-icon"><USPImg src="/assets/img/front/usp/usp-steering-wheel.svg" /></USPIcon>
                <USPText className="usp-text">{props.t('usp_easydrive')}</USPText>
                </USPItem>
            </USPCell>
            <USPCell>
            <USPItem>
                <USPIcon className="usp-icon"><USPImg src="/assets/img/front/usp/usp-cleaner.svg" /></USPIcon>
                <USPText className="usp-text">{props.t('usp_professionalcleaning')}</USPText>
                </USPItem>
            </USPCell>
            <USPCell>
            <USPItem>
                <USPIcon className="usp-icon"><USPImg src="/assets/img/front/usp/usp-privacy.svg" /></USPIcon>
                <USPText className="usp-text">{props.t('usp_privacy')}</USPText>
                </USPItem>
            </USPCell>
            <USPCell>
            <USPItem>
                <USPIcon className="usp-icon"><USPImg src="/assets/img/front/usp/usp-calendar.svg" /></USPIcon>
                <USPText className="usp-text">{props.t('usp_flexiblearrival')}</USPText>
                </USPItem>
            </USPCell>

            <USPCell>
            <USPItem>
                <USPIcon className="usp-icon"><USPImg src="/assets/img/front/usp/usp-24-hours.svg"  /></USPIcon>
                <USPText className="usp-text">{props.t('usp_24hoursupport')}</USPText>
                </USPItem>
            </USPCell>
        </USPContainer>
    )
}

export const USPInner = withTranslator(USPComponent);